<div class="tire-connect-cart-dialog">
  <div class="tire-connect-cart flex-column">
    <!-- Header section -->
    <div class="cart-header flex-between-center flex-row">
      <div class="cart-heading flex-center flex-row">
        <img *ngIf="source === 'tireconnect'" src="assets/img/tireConnect-logo.png" alt="TireConnect Logo"
          class="mr-1" />
        <img *ngIf="source === 'tirehub'" src="assets/img/Tirehub_Logo.svg" alt="TireHub Logo" class="mr-1" />
        <span class="font-16 font-600">Add to cart</span>
      </div>

      <div class="pointer" (click)="handleClose()">
        <i class="fal fa-times font-16 font-300"></i>
      </div>
    </div>

    <!-- Body section -->
    <div class="cart-body-wrapper">
      <!-- tire detail section -->
      <div class="tire-detail-section flex-column flex-start w-100">
        <p class="font-16 font-600">Tire Details</p>

        <div class="tire-specs-section">
          <div class="flex-between-start flex-row">
            <!-- First column -->
            <div class="flex-column">
              <div class="flex-column">
                <span class="font-14 font-400 font-secondary">Name:</span>
                <span class="font-14 font-600">{{tire?.title}}</span>
              </div>

              <div class="flex-column mt-3" [hidden]="!tire?.sideWallStyle">
                <span class="font-14 font-400 font-secondary">Side wall:</span>
                <span class="font-14 font-600">{{tire?.sideWallStyle}}</span>
              </div>
            </div>

            <!-- Second column -->
            <div class="flex-column">
              <div class="flex-column">
                <span class="font-14 font-400 font-secondary">Tire size</span>
                <span class="font-14 font-600">{{tire?.size}}</span>
              </div>

              <div class="flex-column mt-3" [hidden]="!tire?.speedRating">
                <span class="font-14 font-400 font-secondary">Speed rating</span>
                <span class="font-14 font-600">{{tire?.speedRating}}</span>
              </div>
            </div>

            <!-- Third row -->
            <div class="flex-column">
              <div class="flex-column">
                <span class="font-14 font-400 font-secondary">Season</span>
                <span class="font-14 font-600">{{seasonLabel[tire?.seasonality]}}</span>
              </div>

              <div class="flex-column mt-3" [hidden]="!tire?.loadIndex">
                <span class="font-14 font-400 font-secondary">Load index</span>
                <span class="font-14 font-600">{{tire?.loadIndex}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="cart-supplier-section flex-column">
        <p class="font-16 font-600" *ngIf="source === 'tireconnect'">Select Supplier:</p>
        <p class="font-16 font-600" *ngIf="source === 'tirehub'">Select Warehouse:</p>

        <div *ngIf="isLoading" class="flex-row flex-center-center">
          <i class="fal fa-spinner rotate font-20"></i>
        </div>

        <!-- TireConnect section QTQ enabled section-->
        <ng-container *ngIf="!isLoading && source === 'tireconnect'">
          <ng-conatiner *ngIf="isQTQAddOnEnable">
            <div class="cart-supplier-detail flex-column mb-3 border-0">
              <p-accordion class="cart-product-qtq-enhc" [activeIndex]="0">
                <p-accordionTab *ngFor="let availableQtyObj of availableQtyOptions">
                  <p-header>
                    <div class="flex-between-center">
                      <div class="p-2">
                        {{availableQtyObj?.name}}
                      </div>
                      <div class="flex-start-center gap-2">
                        <span class="p-2 added-qty">Added: {{handleTotalAddedTireConnect(availableQtyObj)}}</span>
                        <span class="p-2 qtq-total">Total Qty: {{availableQtyObj?.TotalQty}}</span>
                        <span class="p-2 qtq-cost">Cost: {{(availableQtyObj?.cost || 0) | currency: usd}}</span>
                      </div>
                    </div>
                  </p-header>
                  <div class="supplier-body p-0" *ngIf="['Local', 'Other'].includes(availableQtyObj?.name)">
                    <div class="supplier-attr flex-column">
                      <div class="flex-row table-header ui-g-12">
                        <div class="ui-g-6">
                          <span class="font-600 font-14">Location</span>
                        </div>

                        <div class="ui-g-2">
                          <span class="font-600 font-14">Lead Time</span>
                        </div>

                        <div class="ui-g-2 flex-end-start">
                          <span class="font-600 font-14">Available</span>
                        </div>

                        <div class="ui-g-2 flex-end-start">
                          <span class="font-600 font-14">Qty</span>
                        </div>
                      </div>

                      <div *ngFor="let location of availableQtyObj?.locations"
                        class="flex-row ui-g-12 border-row flex-start-center">
                        <div class="ui-g-6 flex-start-center">
                          <span class="font-400 font-14">{{location?.name}}</span>
                          <span *ngIf="location?.isPrimary" class="badge badge-primary ml-1">
                            Primary
                          </span>
                        </div>

                        <div class="ui-g-2">
                          <span class="font-400 font-14">{{location?.estimatedDeliveryDay}}</span>
                        </div>

                        <div class="ui-g-2 flex-end-start">
                          <span class="font-400 font-14">{{location?.totalAvailable}}</span>
                        </div>

                        <div class="ui-g-2 flex-end-start">
                          <span class="font-400 font-14 w-75">
                            <app-input textAlign="right" [selectTextOnFocus]="true" placeholder="0" theme="border"
                              [value]="location?.count" [isInvalid]="location?.error" mask="0*"
                              (appFocus)="handleFocus(location)" (appBlur)="handleBlur(location)"
                              (appChange)="handleCountChange(location, $event)"></app-input>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <ng-container *ngIf="availableQtyObj?.name === 'Online'">
                    <ng-container *ngFor="let supplier of availableQtyObj?.locations;">
                      <div class="flex-between-center flex-row supplier-header">
                        <div class="supplier-check-box">
                          <app-radio-button [selectedValue]="selectedSupplier" [name]="suppler?.labelName"
                            [label]="supplier?.name" [value]="supplier?.labelName"
                            (appChange)="handleSupplierChange($event)"></app-radio-button>
                        </div>

                        <div class="flex-between-center">
                          <div class="qty-total">Total Qty: {{supplier?.quantity}}</div>
                          <div class="qty-total ml-2">Cost: {{supplier?.cost | currency: usd}}</div>
                        </div>
                      </div>

                      <div class="supplier-body" [hidden]="selectedSupplier !== supplier?.labelName">
                        <div class="supplier-attr flex-column">
                          <div class="flex-row table-header ui-g-12">
                            <div class="ui-g-6">
                              <span class="font-600 font-14">Location</span>
                            </div>

                            <div class="ui-g-2">
                              <span class="font-600 font-14">Lead Time</span>
                            </div>

                            <div class="ui-g-2 flex-end-start">
                              <span class="font-600 font-14">Available</span>
                            </div>

                            <div class="ui-g-2 flex-end-start">
                              <span class="font-600 font-14">Qty</span>
                            </div>
                          </div>

                          <div *ngFor="let location of supplier.locations"
                            class="flex-row ui-g-12 border-row flex-start-center">
                            <div class="ui-g-6 flex-start-center">
                              <span class="font-400 font-14">{{location?.name}}</span>
                              <span *ngIf="location?.isPrimary" class="badge badge-primary ml-1">
                                Primary
                              </span>
                            </div>

                            <div class="ui-g-2">
                              <span class="font-400 font-14">{{location?.estimatedDeliveryDay}}</span>
                            </div>

                            <div class="ui-g-2 flex-end-start">
                              <span class="font-400 font-14">{{location?.totalAvailable}}</span>
                            </div>

                            <div class="ui-g-2 flex-end-start">
                              <span class="font-400 font-14 w-75">
                                <app-input textAlign="right" [selectTextOnFocus]="true" placeholder="0" theme="border"
                                  [value]="location?.count" [isInvalid]="location?.error" mask="0*"
                                  (appFocus)="handleFocus(location)" (appBlur)="handleBlur(location)"
                                  (appChange)="handleCountChange(location, $event)"></app-input>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                </p-accordionTab>
              </p-accordion>
            </div>
          </ng-conatiner>

          <ng-conatiner *ngIf="!isQTQAddOnEnable">
            <div *ngFor="let supplier of tireSupplierDetails;" class="cart-supplier-detail flex-column mb-3">
              <div class="flex-between-center flex-row supplier-header">
                <div class="supplier-check-box">
                  <app-radio-button [selectedValue]="selectedSupplier" [name]="suppler?.labelName"
                    [label]="supplier?.name" [value]="supplier?.labelName"
                    (appChange)="handleSupplierChange($event)"></app-radio-button>
                </div>

                <div class="flex-between-center">
                  <div class="qty-total">Total Qty: {{supplier?.quantity}}</div>
                  <div class="qty-total ml-2">Cost: {{supplier?.cost | currency: usd}}</div>
                </div>
              </div>

              <div class="supplier-body" [hidden]="selectedSupplier !== supplier?.labelName">
                <div class="supplier-attr flex-column">
                  <div class="flex-row table-header ui-g-12">
                    <div class="ui-g-6">
                      <span class="font-600 font-14">Location</span>
                    </div>

                    <div class="ui-g-2">
                      <span class="font-600 font-14">Lead Time</span>
                    </div>

                    <div class="ui-g-2 flex-end-start">
                      <span class="font-600 font-14">Available</span>
                    </div>

                    <div class="ui-g-2 flex-end-start">
                      <span class="font-600 font-14">Qty</span>
                    </div>
                  </div>

                  <div *ngFor="let location of supplier.locations"
                    class="flex-row ui-g-12 border-row flex-start-center">
                    <div class="ui-g-6 flex-start-center">
                      <span class="font-400 font-14">
                        {{location?.name}}
                      </span>
                      <span *ngIf="location?.isPrimary" class="badge badge-primary ml-1">
                        Primary
                      </span>
                    </div>

                    <div class="ui-g-2">
                      <span class="font-400 font-14">{{location?.estimatedDeliveryDay}}</span>
                    </div>

                    <div class="ui-g-2 flex-end-start">
                      <span class="font-400 font-14">{{location?.totalAvailable}}</span>
                    </div>

                    <div class="ui-g-2 flex-end-start">
                      <span class="font-400 font-14 w-75">
                        <app-input textAlign="right" [selectTextOnFocus]="true" placeholder="0" theme="border"
                          [value]="location?.count" [isInvalid]="location?.error" mask="0*"
                          (appFocus)="handleFocus(location)" (appBlur)="handleBlur(location)"
                          (appChange)="handleCountChange(location, $event)"></app-input>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-conatiner>
        </ng-container>

        <!-- TireHub section QTQ enabled section -->
        <ng-container *ngIf="!isLoading && source === 'tirehub'">
          <ng-conatiner *ngIf="isQTQAddOnEnable">
            <div class="cart-supplier-detail flex-column mb-3 border-0">

              <p-accordion class="cart-product-qtq-enhc" [activeIndex]="0">
                <p-accordionTab *ngFor="let availableQtyObj of availableQtyOptions">
                  <p-header>
                    <div class="flex-between-center">
                      <span class="p-2">{{availableQtyObj?.name}}</span>
                      <div class="flex-start-center gap-2">
                        <span class="p-2 added-qty">Added: {{handleTotalAddedCount(availableQtyObj)}}</span>
                        <span class="p-2 qtq-total">Total Qty: {{availableQtyObj?.TotalQty}}</span>
                        <span class="p-2 qtq-cost">Cost: {{(availableQtyObj?.cost || 0) | currency: usd}}</span>
                      </div>
                    </div>
                  </p-header>
                  <div class="supplier-body p-0">
                    <div class="supplier-attr flex-column">
                      <div class="flex-row table-header ui-g-12">
                        <div class="ui-g-6">
                          <span class="font-600 font-14">Location</span>
                        </div>

                        <div class="ui-g-2">
                          <span class="font-600 font-14">Lead Time</span>
                        </div>

                        <div class="ui-g-2 flex-end-start">
                          <span class="font-600 font-14">Available</span>
                        </div>

                        <div class="ui-g-2 flex-end-start">
                          <span class="font-600 font-14">Qty</span>
                        </div>
                      </div>

                      <div *ngFor="let location of availableQtyObj?.locations"
                        class="flex-row ui-g-12 border-row flex-start-center">
                        <div class="ui-g-6">
                          <span class="font-400 font-14">{{location?.name}}</span>
                        </div>

                        <div class="ui-g-2">
                          <span class="font-400 font-14">{{location?.estimatedDeliveryDay}}</span>
                        </div>

                        <div class="ui-g-2 flex-end-start">
                          <span class="font-400 font-14">{{location?.totalAvailable}}</span>
                        </div>

                        <div class="ui-g-2 flex-end-start">
                          <span class="font-400 font-14 w-75">
                            <app-input textAlign="right" [selectTextOnFocus]="true" placeholder="0" theme="border"
                              [value]="location?.count" [isInvalid]="location?.error" mask="0*"
                              (appFocus)="handleFocus(location)" (appBlur)="handleBlur(location)"
                              (appChange)="handleCountChange(location, $event)"></app-input>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </p-accordionTab>
              </p-accordion>
            </div>
          </ng-conatiner>

          <ng-conatiner *ngIf="!isQTQAddOnEnable">
            <div class="cart-supplier-detail flex-column mb-3 border-0">

              <div class="supplier-body p-0">
                <div class="supplier-attr flex-column">
                  <div class="flex-row table-header ui-g-12">
                    <div class="ui-g-6">
                      <span class="font-600 font-14">Location</span>
                    </div>

                    <div class="ui-g-2">
                      <span class="font-600 font-14">Lead Time</span>
                    </div>

                    <div class="ui-g-2 flex-end-start">
                      <span class="font-600 font-14">Available</span>
                    </div>

                    <div class="ui-g-2 flex-end-start">
                      <span class="font-600 font-14">Qty</span>
                    </div>
                  </div>

                  <div *ngFor="let location of locations" class="flex-row ui-g-12 border-row flex-start-center">
                    <div class="ui-g-6">
                      <span class="font-400 font-14">{{location?.name}}</span>
                    </div>

                    <div class="ui-g-2">
                      <span class="font-400 font-14">{{location?.estimatedDeliveryDay}}</span>
                    </div>

                    <div class="ui-g-2 flex-end-start">
                      <span class="font-400 font-14">{{location?.totalAvailable}}</span>
                    </div>

                    <div class="ui-g-2 flex-end-start">
                      <span class="font-400 font-14 w-75">
                        <app-input textAlign="right" [selectTextOnFocus]="true" placeholder="0" theme="border"
                          [value]="location?.count" [isInvalid]="location?.error" mask="0*"
                          (appFocus)="handleFocus(location)" (appBlur)="handleBlur(location)"
                          (appChange)="handleCountChange(location, $event)"></app-input>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-conatiner>
        </ng-container>
      </div>
    </div>

    <div class="cart-footer flex-row flex-end-center">
      <button class="btn btn-border text-center mr-2" (click)="handleClose()">
        <span>Cancel</span>
      </button>

      <button class="btn btn-primary text-center" (click)="handleSubmit()" [disabled]="isLoading || isSaveDisabled"
        *ngIf="source === 'tireconnect'">
        <span>Add to cart</span>
      </button>
      <button class="btn btn-primary text-center" (click)="handleSubmitTireHub()"
        [disabled]="isLoading || isSaveDisabled" *ngIf="source === 'tirehub'">
        <span>Add to cart</span>
      </button>
    </div>
  </div>
</div>
